export default __webpack_public_path__ + "static/media/logo.b0f4e513.png";